import type { FeedbackCollectorConfig } from '@/types/feedbackCollector';

let cachedFeedbackCollectorConfig: FeedbackCollectorConfig | null = null;

export const configService = {
  async getFeedbackCollectorConfig(): Promise<FeedbackCollectorConfig> {
    if (cachedFeedbackCollectorConfig) {
      return cachedFeedbackCollectorConfig;
    }

    const accountToken = import.meta.env.VITE_FEEDBACK_COLLECTOR_ACCOUNT_TOKEN ?? '8ysj675gwbvabokyqa55bxlm9cd4f8d6';

    const defaultFeedbackCollectorConfig: FeedbackCollectorConfig = {
      baseUrl: 'https://mfe.workspace.accessacloud.com/registry/evo-feature-feedback-collector/1/',
      accountToken,
      product: 'ERP Credit Control',
    };

    try {
      const response = await fetch('/config/feedbackCollector.config.json');
      if (!response.ok) {
        console.warn('Feedback collector config not found, using defaults');
        return defaultFeedbackCollectorConfig;
      }

      const configFromFile = await response.json();
      cachedFeedbackCollectorConfig = {
        ...configFromFile,
        accountToken,
      };
      return cachedFeedbackCollectorConfig;
    } catch (error) {
      console.error('Failed to load feedback collector config:', error);
      return defaultFeedbackCollectorConfig;
    }
  },

  clearCache(): void {
    cachedFeedbackCollectorConfig = null;
  },
};
